import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler"
import {txnInitSplitEdit_template} from "../components/templates/txnInitSplitEdit_template";

declare var ko: any;
declare var page: any;

export class txnInitSplit_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected txnInitSplitEdit: txnInitSplitEdit_template;

    protected getModuleName(){
        return "txnInitSplit_edit";
    }

    buildContent() : Array<Element> {
        this.txnInitSplitEdit = new txnInitSplitEdit_template("txnInitSplitEdit_template", this.viewModel, this);
        return [this.txnInitSplitEdit.build()];
    }
    //
    // fill the page at first load.
    fillPage(): void {
        if(this.getVnAppZone().app.params.idBrand != undefined && this.getVnAppZone().app.params.idUser != undefined) {

            this.txnInitSplitEdit.getTemplateViewModel().isEdit(true);
        }
        this.getReferences();
    }

    protected saveEditTxnInitSplit(): void {
        this.save();
    }

    protected cancelEditTxnInitSplit(){

        // redirect to earnings page or user list
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Transaction intitiative split action canceled !");

        page.redirect('/txn_init_split');
    }

    // Getting role data from server.
    public getFormData(): void {

        if(this.getVnAppZone().app.params.idBrand != undefined && this.getVnAppZone().app.params.idUser != undefined) {

            let idBrand = this.getVnAppZone().app.params.idBrand;
            let idUser = this.getVnAppZone().app.params.idUser;
            //this.txnInitSplitEdit.getTemplateViewModel().isEdit(true);

            this.loadingIn(this.txnInitSplitEdit.builtTemplate.children.namedItem("view-results"));

            let usrReq_url: string = '/api/txn_init_split/brand/' + idBrand + '/user/' + idUser + '/get/';
            let usrReq_params: Array<Array<string>> = [];

            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.onGetTxnInitSplitDataReturn;
            this.XHRHdl.execute();
        }else {

            this.txnInitSplitEdit.setInitiativeSplits([]);
        }
    }

    // Handling response data.
    protected onGetTxnInitSplitDataReturn(req, obj): Function {

        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.txnInitSplitEdit.setBrand(response.brand);
                obj.txnInitSplitEdit.setUser(response.user);
                obj.txnInitSplitEdit.setInitiativeSplits(response.initiativeSplits);
                obj.txnInitSplitEdit.validateInitiativeSelector();

                obj.loadingOut(obj.txnInitSplitEdit.builtTemplate.children.namedItem("view-results"));

            });
        }
    }


    private getReferences(): void {

        this.loadingIn(this.txnInitSplitEdit.builtTemplate);

        let usrReq_url: string = '/api/txn_init_split/references/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetReferencesDataReturn;
        this.XHRHdl.execute();
    }


    private onGetReferencesDataReturn(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.updateReferences(response);
                obj.loadingOut(obj.txnInitSplitEdit.builtTemplate);
                obj.getFormData();
            });


        }
    }

    protected save(): void {

        let formReq_url: string = '/api/txn_init_split/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.txnInitSplitEdit.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onPostTxnInitSplitData;
        XHRHdl.execute();
    }

    private onPostTxnInitSplitData(req, obj): Function {
        return function() {

            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Transaction intitiative split saved successfully !");
                page.redirect('/txn_init_split');

            });
        }
    }

    protected updateReferences(response): void {

        this.txnInitSplitEdit.setBrands(response.brands);
        this.txnInitSplitEdit.setInitiatives(response.initiatives);
    }

    public filterDropdownOnChange() {

        this.txnInitSplitEdit.validateInitiativeSelector();
    }

    public filterSimpleOnChange() {

        this.txnInitSplitEdit.validateInitiativeSelector();
    }

    protected getAutoCompleteSuggestions(id, keyword) {

        let subViewModel = {
            filters      : {
                keyword : keyword,
            }
        };
        let usrReq_url: string = '/api/emakiUsers/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetAutoCompleteSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetAutoCompleteSuggestionsReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.txnInitSplitEdit.setUserSelectorItems(response.data);

            });
        }
    }

}



// WEBPACK FOOTER //
// ./js/modules/txnInitSplit_edit.ts